import { Input } from '@crono-one/design-system';
import FormField, {
  FormFieldProps,
} from 'components/CreationForms/base/FormField';
import { useId } from 'react';

export interface FormInputProps extends Omit<
  FormFieldProps,
  'fieldId' | 'children'
> {
  placeholder?: string;
  type?: 'text' | 'number';
  value: string;
  onChange: (value: string) => void;
}

/** One input row of a form: the payload field it fills, with the input's label, placeholder and type. */
export type FormInputRow<F extends string> = { field: F } & Pick<
  FormInputProps,
  'label' | 'placeholder' | 'type'
>;

/** A text input with its label above it, as the creation forms lay out their fields. */
const FormInput = ({
  placeholder,
  type,
  value,
  onChange,
  ...fieldProps
}: FormInputProps) => {
  const id = useId();

  return (
    <FormField {...fieldProps} fieldId={id}>
      <Input
        id={id}
        placeholder={placeholder}
        type={type}
        dsSize="sm"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </FormField>
  );
};

export default FormInput;
